import administrationDashboardMoreRetracted from "~/store/graphql/queries/administrationDashboardMoreRetracted.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminstrationMoreRetracted = async function (
  { commit },
  { params, req, res }
) {
  const data = await runGraphQLQuery(
    administrationDashboardMoreRetracted,
    params,
    this.$axios,
    req,
    res
  );

  const featureToggles = {
    administrationDashboardSiteModerators: this.$unleash.isEnabled(
      "administrationDashboardSiteModerators"
    ),
    showModerationNotes: this.$unleash.isEnabled("showModerationNotes"),
    administrationDashboardAssignCurators: this.$unleash.isEnabled(
      "administrationDashboardAssignCurators"
    ),
  };

  commit("SET_ADMINISTRATION_MORE_RETRACTED", {
    payload: data,
    featureToggles,
  });

  return Promise.resolve(data);
};

export default loadAdminstrationMoreRetracted;
